import StatisticsCabinet from '@/js/components/Pages/Cabinet/StatisticsCabinet'
import StatisticsCoreCabinet from '@/js/components/Pages/Cabinet/StatisticsCoreCabinet'
import NewOrderCabinet from '@/js/components/Pages/Cabinet/NewOrderCabinet'
import CreateOrderCabinet from '@/js/components/Pages/Cabinet/CreateOrderCabinet'
import OrderHistoryCabinet from '@/js/components/Pages/Cabinet/OrderHistoryCabinet'
import BalanceHistoryCabinet from '@/js/components/Pages/Cabinet/BalanceHistoryCabinet'
import BalanceDetailsCabinet from '@/js/components/Pages/Cabinet/BalanceDetailsCabinet'
import InvoiceHistoryCabinet from '@/js/components/Pages/Cabinet/InvoiceHistoryCabinet'
import WithdrawCabinet from '@/js/components/Pages/Cabinet/WithdrawCabinet'
import SettingsCabinet from '@/js/components/Pages/Cabinet/SettingsCabinet'

import { CABINET_ENDPOINTS } from './ENDPOINTS'

const ROUTES = [
  {
    meta: { permissions: ['administrator', 'user'] },
    component: StatisticsCabinet,
    path: CABINET_ENDPOINTS.STATISTICS,
    name: 'StatisticsCabinet',
  },
  {
    meta: { permissions: ['administrator'] },
    component: StatisticsCoreCabinet,
    path: CABINET_ENDPOINTS.STATISTICS_CORE,
    name: 'StatisticsCoreCabinet',
  },
  {
    meta: { permissions: ['administrator', 'user'] },
    component: NewOrderCabinet,
    path: CABINET_ENDPOINTS.NEW_ORDER,
    props: true,
    name: 'NewOrderCabinet',
  },
  {
    meta: { permissions: ['administrator', 'user'] },
    component: CreateOrderCabinet,
    path: CABINET_ENDPOINTS.CREATE_ORDER,
    props: true,
    name: 'CreateOrderCabinet',
  },
  {
    meta: { permissions: ['administrator', 'user'] },
    component: OrderHistoryCabinet,
    path: CABINET_ENDPOINTS.ORDER_HISTORY,
    name: 'OrderHistoryCabinet',
  },
  {
    meta: { permissions: ['administrator', 'user'] },
    component: BalanceHistoryCabinet,
    path: CABINET_ENDPOINTS.BALANCE_HISTORY,
    name: 'BalanceHistoryCabinet',
  },
  {
    meta: { permissions: ['administrator', 'user'] },
    component: BalanceDetailsCabinet,
    path: CABINET_ENDPOINTS.BALANCE_DETAILS,
    name: 'BalanceDetailsCabinet',
  },
  {
    meta: { permissions: ['administrator', 'user'] },
    component: InvoiceHistoryCabinet,
    path: CABINET_ENDPOINTS.INVOICE_HISTORY,
    name: 'InvoiceHistoryCabinet',
  },
  {
    meta: { permissions: ['administrator', 'user'] },
    component: WithdrawCabinet,
    path: CABINET_ENDPOINTS.WITHDRAW,
    name: 'WithdrawCabinet',
  },
  {
    meta: { permissions: ['administrator', 'user'] },
    component: SettingsCabinet,
    path: CABINET_ENDPOINTS.SETTINGS,
    name: 'SettingsCabinet',
  },
]

export default ROUTES



// WEBPACK FOOTER //
// ./src/js/router/cabinet/routes.js